// @flow
import * as R from "ramda"

type Path = string | number | Array<string | number>
type Input = *

const has = R.curry((fullPath: Path, obj: Input): boolean => {
  // $FlowIssue
  const pathArr: Array<string | number> = Array.isArray(fullPath)
    ? fullPath
    : String(fullPath).split(".")

  if (pathArr.length === 0) {
    return R.has(pathArr[0], obj)
  }

  const path = R.init(pathArr)
  const prop = R.last(pathArr)

  if (!path) {
    return false
  }

  const parent = R.path(path, obj)

  return parent && prop ? R.has(prop, parent) : false
})

export default has
